"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleSalesOrderModal = void 0;
const React = require("react");
const react_1 = require("react");
const moment = require("moment-timezone");
const AdapterMoment_1 = require("@mui/lab/AdapterMoment");
const LocalizationProvider_1 = require("@mui/lab/LocalizationProvider");
const lab_1 = require("@mui/lab");
const material_1 = require("@mui/material");
const dialogs_1 = require("../../../../../types/dialogs");
const Modal_1 = require("../../../../../components/base/structure/Modal");
const Button_1 = require("../../../../../components/base/atoms/Button");
const useRetailLocationAvailability_1 = require("../../hooks/useRetailLocationAvailability");
const SalesOrderContext_1 = require("../../contexts/SalesOrderContext");
const RetailLocationsContext_1 = require("../../contexts/RetailLocationsContext");
const overrideMuiTheme_1 = require("./helpers/overrideMuiTheme");
const constants_1 = require("../../../../../helpers/constants");
const currentUnixTimestamp_1 = require("../../../../../apis/spg/util/currentUnixTimestamp");
const useTickReRender_1 = require("../../../../../hooks/useTickReRender");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ScheduleSalesOrderModal");
/**
 * Modal to allow the customer to set a time to schedule to place their order. They can do this before the store opens for later as well
 * as anytime later during opening. This only caters to schedule orders for the current day and if the store is now closed you will not
 * be able to order. It also also allows the customer to reset the schedule to order straight away.
 */
const ScheduleSalesOrderModal = ({ open, setOpen, onScheduledTimeChange }) => {
    var _a;
    const { retailLocation } = (0, react_1.useContext)(RetailLocationsContext_1.RetailLocationsContext);
    const { requestedReadyTime, setRequestedReadyTime } = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext);
    const [tempRequestedReadyTime, setTempRequestedReadyTime] = (0, react_1.useState)(requestedReadyTime);
    const tick = (0, useTickReRender_1.useTickReRender)();
    const { isOperating } = (0, useRetailLocationAvailability_1.useRetailLocationAvailability)(retailLocation);
    const timeZoneId = ((_a = retailLocation === null || retailLocation === void 0 ? void 0 : retailLocation.timezone) === null || _a === void 0 ? void 0 : _a.timeZoneId) || moment.tz.guess();
    const maxDateTime = (0, react_1.useMemo)(() => {
        if (!retailLocation) {
            return null;
        }
        const operationalDay = retailLocation.getOperationalDay(tick);
        const currentDate = moment
            .unix(tick)
            .tz(timeZoneId)
            .format(constants_1.isoDateFormat);
        let momentDate = moment.unix(tick).tz(timeZoneId);
        if (operationalDay === currentDate) {
            momentDate = momentDate.add(1, "d");
        }
        return momentDate.set({ hour: 6, minute: 0, second: 0, millisecond: 0 });
    }, [tick]);
    const updateRequestedReadyTime = (0, react_1.useCallback)(async (scheduledOrderTime) => {
        let success = true;
        if (typeof onScheduledTimeChange === "function") {
            success = await onScheduledTimeChange(scheduledOrderTime);
        }
        setOpen(false);
        if (!success) {
            return;
        }
        setRequestedReadyTime(scheduledOrderTime);
    }, []);
    return (React.createElement(Modal_1.Modal, { open: open, onClose: () => {
            setOpen(false);
        }, size: dialogs_1.TDialogSizes.Small },
        React.createElement("div", { className: css("") },
            React.createElement(Modal_1.ModalHeader, { className: css("header") }, "Schedule Order"),
            React.createElement(Modal_1.ModalBody, null,
                React.createElement("div", { className: css("dateTimePicker") },
                    React.createElement(material_1.ThemeProvider, { theme: overrideMuiTheme_1.theme },
                        React.createElement(LocalizationProvider_1.default, { dateAdapter: AdapterMoment_1.default },
                            React.createElement(lab_1.StaticDateTimePicker
                            // if store is not operating then there's no need to set a time
                            , { 
                                // if store is not operating then there's no need to set a time
                                disabled: !isOperating, minutesStep: 5, 
                                // current set placement time. if null or set time is less than the current tick then it is now
                                value: moment.unix(tempRequestedReadyTime).tz(timeZoneId), 
                                // when the picker is change we temporarily store the value
                                onChange: (newValue) => setTempRequestedReadyTime(newValue.tz(timeZoneId).unix()), renderInput: (params) => (React.createElement(material_1.TextField, Object.assign({}, params))), 
                                // time ranges. this is generally the opening time, or the current time for the minimum if its past that for the minimum and
                                // the closing time for the maximum
                                minDateTime: moment.unix(tick).tz(timeZoneId), maxDateTime: maxDateTime, views: ["day", "hours", "minutes"], ampm: true, ampmInClock: true, openTo: "hours", inputFormat: constants_1.humanTimeFormat }))))),
            React.createElement(Button_1.BlockButton, { className: css("scheduleBtn"), onClick: async () => await updateRequestedReadyTime(tempRequestedReadyTime) }, "Schedule"),
            React.createElement(Button_1.BlockButton, { variant: "secondary", className: css("scheduleBtn"), onClick: async () => {
                    const timestampNow = (0, currentUnixTimestamp_1.currentUnixTimestamp)();
                    await updateRequestedReadyTime(timestampNow);
                } }, "Now"))));
};
exports.ScheduleSalesOrderModal = ScheduleSalesOrderModal;
//# sourceMappingURL=index.js.map